import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon67: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M12.315 0c1.067 0 1.951.793 2.029 1.81l.006.146.003 5.421h2.942c1.647 0 2.907 1.4 2.678 2.953l-.029.161-1.589 7.423c-.248 1.155-1.268 1.992-2.474 2.067l-.173.005-2.928.001c-1.636 0-3.208-.327-4.662-.871A13.882 13.882 0 0 1 7 18.641v.859a.5.5 0 0 1-.5.5H2.729A2.728 2.728 0 0 1 0 17.273V7.008a.5.5 0 0 1 .5-.499h6a.5.5 0 0 1 .5.499v.781l.848-.65.307-.242.282-.229.227-.197c.964-.881 1.537-1.78 1.609-2.724l.007-.203V1.957c0-1.037.836-1.877 1.884-1.952L12.315 0ZM6 7.508H1v9.765c0 .954.774 1.728 1.729 1.728H6V7.508ZM12.315.999c-.535 0-.969.375-1.028.847l-.008.103.001 1.595c0 1.357-.721 2.55-1.941 3.665l-.308.265-.369.298-1.03.786a1.9 1.9 0 0 0-.603 1.379c0 .058-.01.115-.029.167l-.001 7.415.205.107c.369.188.793.377 1.265.554 1.214.454 2.515.745 3.861.799l.45.009 2.928-.001c.765-.001 1.423-.475 1.633-1.145l.036-.137 1.589-7.423c.2-.936-.521-1.825-1.532-1.9l-.139-.005h-3.442a.501.501 0 0 1-.492-.41l-.008-.09-.003-5.92c0-.523-.458-.958-1.035-.958Z"
      />
    </Svg>
  )
}
